// extracted by mini-css-extract-plugin
export default {"content":"InfoPay_content__mOTvD","fields":"InfoPay_fields__s8yw1"};